<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch6">
<div class="chapterHead"><p class="centerImage"><img alt="image" src="images/ch6.jpg" width="5%"/></p>
</div>
<p class="para" style="text-indent: 5%;">Liz looks as scared as you feel. “Don’t be afraid,” the man holding her declares. “The dipping doesn’t hurt … for long.”</p>
<p class="para" style="text-indent: 5%;">“You won’t get away with this!” you warn. “Our teacher, Mr. Dunning, is friends with the owner of this place! He made a personal contribution to the museum.”</p>
<p class="para" style="text-indent: 5%;">“You’re the ones who won’t get away,” says your captor. “He doesn’t know it, but the biggest contribution Mr. Dunning made is you kids! You’ll never see your teacher again!”</p>
<p class="para" style="text-indent: 5%;">“That’s right,” adds Liz’s guard. “Dr. Wicked ordered us to make new figures for the unfinished exhibits before the grand opening of the museum tomorrow.”</p>
<p class="para" style="text-indent: 5%;">“The press and television newspeople are arriving in two hours!” adds the tall man. “We’ve got a lot of body dipping to do in very little time.”</p>
<p class="para" style="text-indent: 5%;">“Body dipping?” you screech. “Where’s Mr. Dunning? Where’s Jake? I demand to see him. <em class="italic">Now!</em>” And you start to scream.</p>
<p class="para" style="text-indent: 5%;">“Scream all you like, kid,” says the short one. “Your friend is being processed. It’s done in stages. First the steaming, then the skinning, then the hot wax dipping. It’s hard to create exhibits of such horrifying quality, you know.”</p>
<p class="para" style="text-indent: 5%;">“But this is supposed to be a history museum!” Liz cries.</p>
<p class="extractLetterText" style="text-indent: 5%;"><em class="italic">Get Liz’s answer on <span href="#/e9780545841733_ch130" title="Link target outside of Sample">PAGE 130</span>.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9780545841733_ch006.vue?54de33f1